import EnrollmentDatasetPropertyField from 'automation-ui-action-features/actions/extension/generic-extension/EnrollmentDatasetPropertyField';
import EnrollmentEventPropertyField from 'automation-ui-action-features/actions/extension/generic-extension/EnrollmentEventPropertyField';
import FetchedObjectPropertyField from 'automation-ui-action-features/actions/extension/generic-extension/FetchedObjectPropertyField';
import FieldDataField from 'automation-ui-action-features/actions/extension/generic-extension/FieldDataField';
import MultiDataField from 'automation-ui-action-features/actions/extension/generic-extension/MultiDataField';
import PropertyField from 'automation-ui-action-features/actions/extension/generic-extension/PropertyField';
import RelativeDatetimeField from 'automation-ui-action-features/actions/extension/generic-extension/RelativeDatetimeField';
import SingleObjectCoordinatesField from 'automation-ui-action-features/actions/extension/generic-extension/SingleObjectCoordinatesField';
import StaticField from 'automation-ui-action-features/actions/extension/generic-extension/StaticField';
export const convertPropertyValueToFieldValue = value => {
  var _value$timeDelay;
  switch (value === null || value === void 0 ? void 0 : value.type) {
    case 'ENROLLMENT_DATASET_COLUMN':
      return new EnrollmentDatasetPropertyField({
        propertyToken: value.propertyToken
      });
    case 'ENROLLMENT_EVENT_PROPERTY':
      return new EnrollmentEventPropertyField({
        propertyToken: value.propertyToken
      });
    case 'FETCHED_OBJECT_PROPERTY':
      return new FetchedObjectPropertyField({
        propertyToken: value.propertyToken
      });
    case 'FIELD_DATA':
      return new FieldDataField({
        fieldDataIdentifier: value.identifier
      });
    case 'MULTI_VALUE':
      return new MultiDataField({
        value: Array.isArray(value.value) ? value.value : null
      });
    case 'OBJECT_PROPERTY':
      return new PropertyField({
        propertyName: value.propertyName
      });
    case 'RELATIVE_DATETIME':
      return new RelativeDatetimeField({
        timeDelay: (_value$timeDelay = value.timeDelay) === null || _value$timeDelay === void 0 ? void 0 : _value$timeDelay.toJSON()
      });
    case 'SINGLE_OBJECT_COORDINATES':
      return new SingleObjectCoordinatesField({
        coordinatesToken: value.coordinatesToken
      });
    case 'STATIC_VALUE':
    default:
      {
        const _value = value === null || value === void 0 ? void 0 : value.getValue();
        return new StaticField({
          value: _value != null ? `${_value}` : null
        });
      }
  }
};